import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getTotesEspecies,
  getTotesFenofases,
  getTotesClasses
} from "../../reducers";
import styles from "./VisualitzacioSelectorEspecie.module.css";
import {
  omplirIdEspecieVisualitzacio,
  omplirIdFenofaseVisualitzacio
} from "../../actions";
import { getIdEspecie } from "../../reducers";
import { Select } from "antd";
const SEPARADOR = "#%";

class VisualitzacioSelectorEspecie extends Component {
  handleOnChange = opcioSeleccionada => {
    const idEspecie = opcioSeleccionada.substr(
      opcioSeleccionada.indexOf(SEPARADOR) + SEPARADOR.length
    );
    const { fenofases } = this.props;
    const constIdEspecieInt = isNaN(parseInt(idEspecie))
      ? 0
      : parseInt(idEspecie);

    const {
      omplirIdEspecieVisualitzacio,
      omplirIdFenofaseVisualitzacio
    } = this.props;

    omplirIdEspecieVisualitzacio(constIdEspecieInt);

    const fenofasesEspecieSeleccionada = fenofases.filter(fenofase => {
      return constIdEspecieInt === fenofase.idEspecie;
    });

    if (fenofasesEspecieSeleccionada.length === 1) {
      omplirIdFenofaseVisualitzacio(fenofasesEspecieSeleccionada[0].id);
    }
  };

  ordenarArrayObjectesDesc = (a, b) => {
    if (a.nom < b.nom) {
      return -1;
    }
    if (a.nom > b.nom) {
      return 1;
    }
    return 0;
  };

  render() {
    const { classes, especies, idEspecie } = this.props;
    // Si no hi ha especie seleccionada, el selector ens retorna null. Però per a Antd
    // valor no seleccionat és undefined, per tant s'ha de transformar. Es podria fer directament
    // a Redux, però estaríem acoplant l'estat al Select d'Antd, cosa no desitjable.
    if (
      !classes ||
      !Array.isArray(classes) ||
      !especies ||
      !Array.isArray(especies)
    ) {
      return null;
    }

    const { Option, OptGroup } = Select;
    const llistaEspecieSeleccionada = especies.filter(especie => {
      return especie.id === idEspecie;
    });

    const nomEspecieSeleccionada =
      llistaEspecieSeleccionada && llistaEspecieSeleccionada.length > 0
        ? llistaEspecieSeleccionada[0].nom
        : "";

    const valor =
      nomEspecieSeleccionada && idEspecie
        ? nomEspecieSeleccionada + SEPARADOR + idEspecie
        : "Selecciona una espècie...";
    return (
      <div className={styles.visualitzacioSelector}>
        <label htmlFor="id-especie">Seleccionar l'especie</label>
        <Select
          showSearch
          style={{ width: "100%", maxHeight: 100 }}
          id="id-especie"
          onChange={this.handleOnChange}
          value={valor}
        >
          {classes.map(classe => (
            <OptGroup key={classe.id} label={classe.nom}>
              {especies
                .filter(especie => {
                  return especie.idClasse === classe.id;
                })
                .slice()
                .sort(this.ordenarArrayObjectesDesc)
                .map(especie => (
                  <Option
                    key={especie.id}
                    value={especie.nom + SEPARADOR + especie.id}
                  >
                    {especie.nom}
                  </Option>
                ))}
            </OptGroup>
          ))}
        </Select>
      </div>
    );
  }
}
VisualitzacioSelectorEspecie.propTypes = {
  omplirIdEspecieVisualitzacio: PropTypes.func.isRequired,
  especies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired
    })
  ),
  idEspecie: PropTypes.number,
  classes: PropTypes.array
};

const mapStateToProps = state => {
  return {
    especies: getTotesEspecies(state),
    fenofases: getTotesFenofases(state),
    classes: getTotesClasses(state),
    idEspecie: getIdEspecie(state)
  };
};

export default connect(mapStateToProps, {
  omplirIdEspecieVisualitzacio,
  omplirIdFenofaseVisualitzacio
})(VisualitzacioSelectorEspecie);
